<script>
  import { Form, store } from '$client';
  import { onMount } from 'svelte';
  export let data;

  const { modal: open } = store;
  const state = new FormData();
  let step = 0;
  const handle = async (formData, send) => {
    const key = 'step' + step;
    if (key) state.delete(key);
    Array.from(formData).forEach(([k, v]) => state.append(k, v));
    if (step < data[$open].steps.data.length - 1) return void step++;
    const isErr = await send(state, data[$open].url);
    if (isErr) return;
    step++;
  };

  let elClicked = false;
  const alertListener = () => (elClicked = $open !== -1 ? true : false);
  const windowListener = e => {
    if (e.target.tagName.toLowerCase() === 'button') return void 0;
    if (elClicked) return void (elClicked = false);
    return void store.modal.set(-1);
  };

  onMount(() => {
    const elements = [...document.getElementsByClassName('modal-dialog')];
    elements.forEach(e => e.addEventListener('click', alertListener));
    window.addEventListener('click', windowListener);
    return () => {
      elements.forEach(e => e.removeEventListener('click', alertListener));
      window.removeEventListener('click', windowListener);
    };
  });
</script>

{#each Object.entries(data) as [key, modal]}
  <dialog class="modal-dialog" open={String($open) === key} style="display: {String($open) == key ? 'flex' : 'none'};">
    <button aria-label="Закрыть модальное окно" on:click={() => store.modal.set(-1)} />
    {#each modal.steps.data as form, i}
      <Form
        hook={handle}
        attributes={{ 'data-step': i, style: 'display: ' + (i === step ? 'flex' : 'none') }}
        data={form.attributes}>
        {#if modal.steps.data.length > 1}
          <section class="step">
            <h3>Шаг {step + 1} из {modal.steps.data.length}</h3>
            <progress max={modal.steps.data.length} value={step} />
            {#if step !== 0}
              <button type="button" on:click={() => step--}>Назад</button>
            {/if}
          </section>
        {/if}
      </Form>
    {/each}
    <section style={modal.steps.data.length === step ? 'display:block;' : 'display:none;'}>
      <h2>{modal.finish?.header ?? 'Заявка оформлена'}</h2>
      <div>
        <p>Готово !</p>
        <progress max={modal.steps.data.length} value={step} />
      </div>
      {#if modal.finish?.description}
        <p>{@html modal.finish.description}</p>
      {/if}
      <button on:click={() => store.modal.set(0)}>{modal.finish?.button ?? 'Хорошо'}</button>
    </section>
  </dialog>
{/each}

<style lang="scss">
  dialog {
    position: fixed;
    top: 20px;
    left: 50%;
    z-index: 150;
    display: none;
    min-width: 640px;
    max-width: 640px;
    max-height: 640px;
    padding: 28px 40px;
    overflow-y: auto;
    background: #fff;
    border: none;
    border-radius: 10px;
    box-shadow: 0 0 20px rgb(0 0 0 / 10%);
    transform: translateX(-50%);
    transition: transform 0.4s ease-in-out;

    @media only screen and (max-width: 767.98px) {
      width: calc(100% - 40px);
      min-width: auto;
      padding: 10px 30px;
    }

    > button {
      position: absolute;
      top: 15px;
      right: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      background: #22eaac;
      border-radius: 50%;
      box-shadow: 0 0 10px rgb(0 0 0 / 10%);

      @media only screen and (max-width: 767.98px) {
        width: 20px;
        height: 20px;
      }

      &::after,
      &::before {
        position: absolute;
        display: block;
        width: 3px;
        height: calc(100% - 30%);
        background: #fff;
        content: '';
      }

      &::after {
        transform: rotate(45deg);
      }

      &::before {
        transform: rotate(-45deg);
      }
    }

    section {
      p,
      h3 {
        margin-bottom: 8px;
        color: #2c333c;
        font-weight: 600;
        font-size: 16px;
        font-family: Vela Sans;
        font-style: normal;
        line-height: 140%; /* 22.4px */

        @media only screen and (max-width: 767.98px) {
          font-size: 14px;
        }
      }
    }

    .step,
    section:last-child > div {
      width: 100%;
      margin-bottom: 40px;

      progress {
        width: 100%;
        height: 12px;
        border-radius: 6px;
      }

      button {
        display: inline-flex;
        align-items: center;
        width: 100%;
        margin-top: 13px;
        color: #77818f;
        font-weight: 600;
        font-size: 16px;

        /* Txt_Button_16 */
        font-family: Vela Sans;
        font-style: normal;
        line-height: 140%; /* 22.4px */

        &::before {
          display: block;
          width: 24px;
          height: 24px;
          margin-right: 5px;
          background-image: url('https://admin.uberi.pro/uploads/arrow_left_f709790ac9.svg');
          content: '';
        }
      }
    }

    :global(form:not(:last-child) > .agree) {
      display: none;
    }

    :global(form > h2),
    section:last-child h2 {
      margin-bottom: 20px;
      color: #2c333c;
      font-weight: bold;
      font-size: 24px;
      font-family: Vela Sans;
      font-style: normal;
      line-height: 140%; /* 33.6px */

      @media only screen and (max-width: 767.98px) {
        font-size: 20px;
      }
    }

    :global(form > div) {
      flex-direction: column;
      gap: 15px;
    }

    :global(form > p),
    section:last-child > p {
      margin-bottom: 28px;
      color: #77818f;
      font-weight: normal;
      font-size: 16px;
      font-family: Vela Sans;
      font-style: normal;
      line-height: 130%; /* 20.8px */
    }

    :global(form > button),
    section:last-child button {
      width: 100%;
      margin-top: 50px;
      padding: 18px 40px;
      background: #22eaac;
      border-radius: 5px;
    }
  }
</style>
